<template>
  <div class="addDevice">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'mydevice' }">我的设备</el-breadcrumb-item>
      <el-breadcrumb-item>添加设备</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider />
    <div class="main">
      <div class="fr ac add_cell">
        <p class="fs device_name need">设备名称:</p>
        <el-cascader
          size="mini"
          class="ml20 right"
          v-model="select_device_name"
          :options="deviceclass_list"
          :props="{ children: 'deviceBeans',value:'device_id',label:'device_name' }"
        ></el-cascader>
      </div>
      <div class="fr ac mt20 add_cell">
        <p class="fs device_name">设备别名:</p>
        <el-input size="mini" class="ml20 right" v-model="company_device_name"></el-input>
      </div>
      <div class="fr ac mb20 add_cell">
        <p class="fs need device_name">设备图片:</p>
        <up-load :file_list.sync="device_imgs" :limit="1" />
      </div>
      <div class="mt40 add_cell fr">
        <p class="fs device_name"></p>
        <el-button type="primary" @click="insertMemberDevice" class="ml20">添加设备</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import UpLoad from "@/components/UploadImg";
export default {
  props: {},
  data() {
    return {
      deviceclass_list: [],
      select_device_name: "",
      company_device_name: "",
      device_imgs: []
    };
  },
  computed: {},
  created() {
    this.getDeviceClass();
  },
  watch: {},
  methods: {
    getDeviceClass() {
      this.post("goodsInterfaces/v1.0/getDeviceList").then(res => {
        let arr = res.data;
        arr.forEach(el => {
          el.device_name = el.class_name;
          el.device_id = el.class_id;
        });
        this.deviceclass_list = arr;
      });
    },
    insertMemberDevice() {
      if (!this.select_device_name.length) {
        this.$message({
          message: "请选择或输入设备名称",
          type: "warning"
        });
        return;
      }
      if (!this.device_imgs.length) {
        this.$message({
          message: "请上传机器图片",
          type: "warning"
        });
        return;
      }
      let obj = {};
      this.deviceclass_list.forEach(el => {
        if (el.device_id == this.select_device_name[0]) {
          el.deviceBeans.forEach(e => {
            if (e.device_id == this.select_device_name[1]) {
              obj.device_name = e.device_name;
              obj.device_id = e.device_id;
            }
          });
        }
      });

      obj.company_device_name = this.company_device_name;
      obj.company_device_img = this.device_imgs.join(",");

      this.post("companyInterfaces/v1.0/insertCompanyDevice", obj).then(res => {
        this.$message({
          message: res.data,
          type: "success"
        });
      });
    }
  },
  components: { "up-load": UpLoad }
};
</script>

<style scoped lang="scss">
.addDevice {
  font-size: 14px;
  .main {
    padding-left: 100px;
    .add_cell {
      // width: 300px;
      .device_name {
        width: 100px;
        text-align: right;
      }
      .right {
        width: 180px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myDevice/addDevice.vue